import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import { useStore } from '../../context/StoreContext';
import styles from './Layout.module.css';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { activeStore } = useStore();
  // The page is rebuilt when the branch (or HQ) changes, so nothing from the old branch stays on screen
  const branchKey = String(activeStore?._id || activeStore?.id || 'none');

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div className={styles.layoutWrapper}>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={styles.mainContent}>
        <Navbar toggleSidebar={toggleSidebar} />
        <main className={styles.pageContent}>
          <div className={styles.pageContainer}>
            <Outlet key={branchKey} />
          </div>
        </main>
      </div>

      {isSidebarOpen && (
        <div className={styles.mobileOverlay} onClick={toggleSidebar} aria-label="Close sidebar" role="presentation" />
      )}
    </div>
  );
};

export default Layout;